import React, { createContext, useState, useEffect, useCallback } from "react";

const ThemeContext = createContext({
    isChristmasTheme: false,
    toggleChristmasTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
    const [isChristmasTheme, setIsChristmasTheme] = useState(() => {
        const saved = localStorage.getItem("christmas-theme");
        return saved === "true";
    });

    useEffect(() => {
        if (isChristmasTheme) {
            document.body.setAttribute("data-theme", "christmas");
        } else {
            document.body.removeAttribute("data-theme");
        }
    }, [isChristmasTheme]);

    const toggleChristmasTheme = useCallback(() => {
        setIsChristmasTheme((prev) => {
            const newValue = !prev;
            localStorage.setItem("christmas-theme", String(newValue));
            return newValue;
        });
    }, []);

    const value = {
        isChristmasTheme,
        toggleChristmasTheme,
    };

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeContext;
